import { customAxios as axios, getToken } from '../../../request'
import { hidePageLoad, showPageLoad } from '../../../modules/actions'
import { approveAdvanceCommissionUrl, ListAllAgentCommissionsUrl, ListAllApprovedAgentCommissionsUrl } from '../apis'
import { notification } from 'antd'

export const getAllAdvanceCommissionsFxn = filters => async dispatch => {
  let config = {
    params: { ...filters },
    ...(await getToken())
  }
  let { data } = await axios.get(ListAllAgentCommissionsUrl(), config)
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}

export const approveAdvanceCommissionFxn = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.post(approveAdvanceCommissionUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  if (data.success) {
    notification.success({
      message: data.message || 'Error'
    })
  }

  return data
}

export const getAllApprovedAdvanceCommissionsFxn = filters => async dispatch => {
  let config = {
    params: { ...filters },
    ...(await getToken())
  }
  let { data } = await axios.get(ListAllApprovedAgentCommissionsUrl(), config)
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}

